import { render, staticRenderFns } from "./User-login-v2.vue?vue&type=template&id=fc8afd7a&"
import script from "./User-login-v2.vue?vue&type=script&lang=js&"
export * from "./User-login-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports